module.exports = __webpack_public_path__ + "static/media/closeInputter.1ca4a826.svg";